import gql from "graphql-tag";

const SUB_UNREAD_COUNT = gql`
    subscription inAppNotification {
      inAppNotification
    }
`;

export default SUB_UNREAD_COUNT;